import React from 'react'
import PropTypes from 'prop-types'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import DOMPurify from 'dompurify';
import { htmlDecode } from '../../_global/js/Utils.js';

const Explanation = props => {

  const { matrixData } = useStore(state =>({
    matrixData: state.matrixData,
}), shallow);

  const explanationContentWithEscapedChars = matrixData['pages'][props.pageId]['explanatory_content'];
  const explanationContent = htmlDecode(explanationContentWithEscapedChars);

  return (
    <div className="explanation" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(explanationContent)}} />
    // <div className="explanation">
    //   {explanationContent}
    // </div> 

  )
}

Explanation.propTypes = {
  pageId: PropTypes.string
}

export default Explanation